module.exports = __webpack_public_path__ + "static/media/man_xuexiaofeng.43bda92b.png";